import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'auth';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Logger, User } from 'shared';
import { Settings } from '../models';

type BootstrapResponse = {settings?: Settings, user: User };
@Injectable({
  providedIn: 'root'
})
export class BootstrapService {

  private settings: Settings | null = null;
  protected logger = new Logger('BootstrapService');

  constructor(private http: HttpClient, private authService: AuthService) {}

  bootstrap(): Observable<boolean> {
    this.logger.debug('============= BOOTSTRAP START');
    return this.http.get<BootstrapResponse>('/bootstrap').pipe(
      map(response => {
        this.logger.debug('============= BOOTSTRAP DONE > ', response);
        this.settings = response.settings || {};
        this.authService.setAuthState(response.user);
        return true;
      }),
      catchError((error) => {
        this.logger.debug('============= BOOTSTRAP ERROR > ', error);
        this.settings = {};
        this.authService.setAuthState(null);
        return of(false);
      })
    );
  }

  getSettings(): Settings | null {
    return this.settings;
  }

  getSetting<K extends keyof Settings>(key: K): Settings[K] {
    return this.settings?.[key];
  }
}